// import { ValidationRule } from 'devextreme-react/data-grid';
// import React from 'react';
import styles from './readyProductsTable.module.scss';

const columnDataGrid = [
  {
    dataField: 'batchId',
    caption: 'Партия SAP',
    dataType: 'string',
    groupIndex: 1
  },
  {
    dataField: 'qcId',
    caption: '№СК',
    dataType: 'string',
    groupIndex: 2
  },
  {
    dataField: 'cgId',
    caption: 'Номер партии',
    dataType: 'string',
    groupIndex: 3
  },
  {
    dataField: 'actualPieceId',
    caption: 'Номер УЕ',
    dataType: 'string',
    groupIndex: 4
  },
  {
    dataField: 'quantity',
    caption: 'Кол-во',
    dataType: 'number',
    groupIndex: 5
  },
  {
    dataField: 'unitShortName',
    caption: 'ЕИ',
    dataType: 'string',
    groupIndex: 6
  },
  {
    dataField: 'percentWasteMaterial',
    caption: '% отходов',
    dataType: 'number',
    groupIndex: 7
  },
  {
    dataField: 'quantityCurrent',
    caption: 'Кол-во, тек.',
    dataType: 'number',
    groupIndex: 8
  },
  {
    dataField: 'weightWasteMaterialCurrent',
    caption: 'Кол-во всех отходов, текущее',
    notVisible: true,
    dataType: 'number',
    groupIndex: 9
  },
  {
    dataField: 'quantityRemain',
    caption: 'Кол-во ост.',
    dataType: 'number',
    groupIndex: 10
  },
  {
    dataField: 'quantityOff',
    caption: 'Кол-во списания',
    dataType: 'number',
    allowEditing: true,
    cssClass: styles.editableCell,
    groupIndex: 11
  },
  {
    dataField: 'pieceNumId',
    caption: 'Ключ УЕ ПФ',
    notVisible: true,
    dataType: 'integer',
    groupIndex: 12
  }
];

export default columnDataGrid;
